export default "__VITE_ASSET__DmE5Ztc9__"